import { UTSLocale } from "@smile2impress/attraction-constants";

import spain from "./spain";
import portugal from "./portugal";
import italy from "./italy";
import uk from "./uk";
import us from "./us";

export default {
    [UTSLocale.SPAIN_ES]: spain,
    [UTSLocale.PORTUGAL_PT]: portugal,
    [UTSLocale.ITALY_IT]: italy,
    [UTSLocale.GB_EN]: uk,
    [UTSLocale.FRANCE_FR]: spain,
    [UTSLocale.UKRAINE_UK]: spain,
    [UTSLocale.US_EN]: us,
    [UTSLocale.NL_NL]: uk,
    [UTSLocale.GERMANY_DE]: uk,
    [UTSLocale.SWEDEN_SE]: uk,
    [UTSLocale.DENMARK_DK]: uk,
};
